import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M185-185h44l443-442-43-44-444 442v44Zm-40 79q-16 0-28-11-11-12-11-28v-83q0-15 6-31 7-15 18-26l550-549q8-10 21-15 12-5 25-5 12 0 25 5 12 5 22 14l63 61q10 11 14 23 5 12 5 25t-5 26q-5 12-14 21L286-130q-12 11-27 18-14 6-30 6h-84Zm625-621-42-42 42 42Zm-119 77-22-21 43 44-21-23Z"/>',
  f: '<path d="M145-106q-16 0-28-11-11-12-11-28v-83q0-15 6-31 7-15 18-26l550-549q8-10 21-15 12-5 25-5 12 0 25 5 12 5 22 14l63 61q10 11 14 23 5 12 5 25t-5 26q-5 12-14 21L286-130q-12 11-27 18-14 6-30 6h-84Zm585-581 40-40-42-42-40 40 42 42Z"/>',
};

export default data;
